import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-survey-short-answer',
  templateUrl: './preview-survey-short-answer.component.html',
  styleUrls: ['./preview-survey-short-answer.component.scss']
})
export class PreviewSurveyShortAnswerComponent {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
  descriptiveQuestion: any;

  ngOnInit(): void {
    this.descriptiveQuestion = this.questions?.questiondescription?.description;
  }

}
